<!-- counrier new div with 190px max height -->
<!-- <pre style="max-height: 190px; overflow-y: auto; overflow-x: auto"
    >{{ csvData }}
</pre> -->

<!-- <nz-table #table [nzData]="rawDataSource" [nzBordered]="true" nzSize="small">   
    <thead>
        <tr>
            <th *ngFor="let column of rawDataSource[0]">{{ column }}</th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let row of table.data">
            <td *ngFor="let cell of row">{{ cell }}</td>
    </tbody>
</nz-table> -->
<table class="bordered-table">
    <tr *ngFor="let row of rawDataSource" class="bordered-row">
        <td *ngFor="let cell of row" class="row-content">{{ cell }}</td>
    </tr>
</table>
